import type { Status } from '@xleddyl/types'

type StatusProps = {
   icon: string
   colorClass: string
}

export const getStatusProps = (type?: Status): StatusProps => {
   switch (type) {
      case 'error':
         return { icon: 'ban', colorClass: 'text-red' }
      case 'success':
         return { icon: 'check-circle', colorClass: 'text-green' }
      case 'info':
         return { icon: 'information-circle', colorClass: 'text-grey' }
      case 'primary':
         return { icon: 'information-circle', colorClass: 'text-primary' }
      case 'warning':
      default:
         return { icon: 'information-circle', colorClass: 'text-yellow' }
   }
}
